// stub
export const socket: any = {};
